import useFetchProjectMembersQuery from '@projectMembers/queries/useFetchProjectMembersQuery';
import useFetchProjectPendingInvitationsQuery from '@projectMembers/queries/useFetchProjectPendingInvitationsQuery';
import Project from 'src/entities/project';
import useFetchCurrentUserQuery from 'src/new_arch/modules/authentication/queries/useFetchCurrentUserQuery';
import useModal from 'src/new_arch/hooks/useModal';

type ShareProjectModalProps = {
	project: Project
	onClose: () => void
};

const defaultModalStyles = {
	content: { background: 'transparent' },
	header: { padding: '10px 16px', backgroundColor: 'var(--color-bg-container)', borderRadius: '8px 8px 0 0' },
	title: { color: 'var(--color-text-primary)' },
	close: { color: 'var(--color-text-primary)' },
	body: { padding: 0, background: 'transparent' }
};

const useShareProjectModal = ( { project, onClose }: ShareProjectModalProps ) => {
	const { opened, modalStyles } = useModal( {
		name: 'share-project',
		onClose,
		stackOrder: 1,
		defaultStyles: defaultModalStyles,
		preventEscEventBubble: false
	} );

	const { data: currentUser } = useFetchCurrentUserQuery();
	const { data: members } = useFetchProjectMembersQuery( { projectID: project.id } );
	const { data: invitations } = useFetchProjectPendingInvitationsQuery( { projectID: project.id } );
	const totalCount = ( members?.length ?? 0 ) + ( invitations?.length ?? 0 );
	const canEditProject = project.currentUserRole.permissions.currentUserCan( 'edit', 'projects' );
	const canShareInviteLink = project.currentUserRole.permissions.currentUserCan( 'shareInviteLink', 'projects' );

	return {
		opened,
		modalStyles,
		totalCount,
		showManageReviewerRole: canEditProject,
		showViewOnlyLink: canShareInviteLink,
		currentUserID: currentUser!.id
	};
};

export default useShareProjectModal;
